import Header from './Header';
import background from './img/softwarePartners.webp';
import screenshotWordpressUpload from './img/screenshot-wp-uploadpng.png';
import screenshotWpAdd from './img/screenshot-wp-add.png';
import screenshotWpUploadPlugin from './img/screenshot-wp-uploadplugin.png';
import screenshotWpPluginPage from './img/screenshot-wp-plugin-page.png';
import screenshotWooCommerceSettings from './img/screenshot-woo-commerce-settings.png';
import screenshotWooCommercePaymentGateway from './img/screenshot-woo-commerce-payement-gateway.png';
import screenshotDeveloperHub from './img/screenshot-developer-hub.webp';
import screenshotCreateNewApp from './img/screenshot-create-new-application.webp';
import screenshotSecrets from './img/screenshot-secrets.webp';
import screenshotWooCommerceGatewaySettings from './img/screenshot-woo-commerce-gateway-settings.webp';
import screenshotWebhooks from './img/screenshot-webhooks.webp';
import screenshotAcceptableMethods from './img/screenshot-accepted-methods.webp';
import screenshotLogging from './img/screenshot-logging.webp';
import screenshotPaymentAdjustments from './img/screenshot-woo-settings-payment-adjustments.png';
import screenshotLabelWarning from './img/screenshot-woo-settings-label-warning.png';
import screenshotCheckoutAdminFee from './img/screenshot-woo-checkout-blocks-debit.png';
import screenshotSurchargeNotice from './img/screenshot-woo-checkout-classic-surcharge-notice.png';
import screenshotOrderThankYou from './img/screenshot-woo-order-thankyou.png';
import screenshotOrderAdmin from './img/screenshot-woo-order-admin.png';
import screenshotGeneralSettings from './img/screenshot-woo-settings-general.png';
import screenshotSubscriptionSettings from './img/screenshot-woo-settings-subscriptions.png';
import screenshotCheckoutCard from './img/screenshot-woo-checkout-card.png';
import screenshotCheckoutAch from './img/screenshot-woo-checkout-ach.png';
import screenshotOrderRefund from './img/screenshot-woo-order-refund.png';
import MobileNavigation from './MobileNavigation';
import { CopyBlock, dracula } from 'react-code-blocks';
import Footer from './Footer';
import { Link } from 'react-router-dom';
import { Section, openSection } from './DocSection';

const DeveloperWooCommerce = () => {
  return (
    <>
      <MobileNavigation />
      <section className="bg-[#212121] woo-commerce">
        <div
          className="w-full pb-28"
          style={{
            backgroundImage: `url(${background})`,
            backgroundSize: '200% 200%',
            backgroundPosition: 'bottom center',
            backgroundRepeat: 'no-repeat'
          }}
        >
          <Header />
          <div className="p-4 row md:p-8 how">
            <h3 className="text-white large">iQ Pro+ WooCommerce Plugin</h3>
          </div>
          <div className="flex p-16 row flex-col justify-center flex-start gap-6 self-stretch rounded-[28px] bg-white !mb-10">
            <h2 className="text-black large">Overview</h2>
            <p
              className="text-black light"
              style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
            >
              The{' '}
              <Link
                to="/integrations-woo-commerce-downloads"
                style={{ color: '#007bff', textDecoration: 'underline' }}
              >
                iQ Pro+ payment gateway plugin
              </Link>{' '}
              provides seamless integration between WooCommerce and your iQ Pro+ Gateway, enabling
              merchants to accept credit card and ACH payments with secure, PCI-compliant
              tokenization. The plugin features customer payment method vaulting, allowing logged-in
              users to save and manage payment methods for faster checkouts. It supports both the
              classic and Block checkout, automatic recurring billing for WooCommerce Subscriptions,
              and optional admin fees with credit card surcharge disclosure. This guide walks you
              through configuring and using the plugin, including setup, payment processing,
              customer vaulting, subscriptions, and managing transactions through the WooCommerce
              admin interface.
            </p>
            <h2 className="font-normal text-black">On this page</h2>
            <ol className="ml-5 list-decimal gap-x-12 marker:text-gray-500 md:columns-2 [&>li]:break-inside-avoid [&>li]:py-1">
              <li className="text-black light">
                <a
                  onClick={openSection}
                  href="#installation-and-setup"
                  style={{ color: '#007bff', textDecoration: 'underline' }}
                >
                  Installation &amp; Setup
                </a>
              </li>
              <li className="text-black light">
                <a
                  onClick={openSection}
                  href="#app-registration-setup"
                  style={{ color: '#007bff', textDecoration: 'underline' }}
                >
                  App Registration Setup
                </a>
              </li>
              <li className="text-black light">
                <a
                  onClick={openSection}
                  href="#settings-page"
                  style={{ color: '#007bff', textDecoration: 'underline' }}
                >
                  Settings Page
                </a>
              </li>
              <li className="text-black light">
                <a
                  onClick={openSection}
                  href="#credentials-and-environment"
                  style={{ color: '#007bff', textDecoration: 'underline' }}
                >
                  Credentials and Environment
                </a>
              </li>
              <li className="text-black light">
                <a
                  onClick={openSection}
                  href="#webhook-setup"
                  style={{ color: '#007bff', textDecoration: 'underline' }}
                >
                  Webhook Setup
                </a>
              </li>
              <li className="text-black light">
                <a
                  onClick={openSection}
                  href="#webhook-creation"
                  style={{ color: '#007bff', textDecoration: 'underline' }}
                >
                  Webhook Creation
                </a>
              </li>
              <li className="text-black light">
                <a
                  onClick={openSection}
                  href="#accepted-methods"
                  style={{ color: '#007bff', textDecoration: 'underline' }}
                >
                  Accepted Methods
                </a>
              </li>
              <li className="text-black light">
                <a
                  onClick={openSection}
                  href="#payment-adjustments"
                  style={{ color: '#007bff', textDecoration: 'underline' }}
                >
                  Payment Adjustments &amp; Surcharges
                </a>
              </li>
              <li className="text-black light">
                <a
                  onClick={openSection}
                  href="#recurring-billing"
                  style={{ color: '#007bff', textDecoration: 'underline' }}
                >
                  Recurring Billing
                </a>
              </li>
              <li className="text-black light">
                <a
                  onClick={openSection}
                  href="#refunds"
                  style={{ color: '#007bff', textDecoration: 'underline' }}
                >
                  Refunds
                </a>
              </li>
              <li className="text-black light">
                <a
                  onClick={openSection}
                  href="#logging"
                  style={{ color: '#007bff', textDecoration: 'underline' }}
                >
                  Logging
                </a>
              </li>
              <li className="text-black light">
                <a
                  onClick={openSection}
                  href="#styling"
                  style={{ color: '#007bff', textDecoration: 'underline' }}
                >
                  Styling
                </a>
              </li>
            </ol>
            <h2 className="font-normal text-black">Prerequisites</h2>
            <p className="text-black light">
              This plugin currently is compatible with the following versions of WordPress
            </p>
            <table className="tg" style={{ undefined, tableLayout: 'fixed', width: '100%' }}>
              <colgroup>
                <col style={{ width: '25%' }} />
                <col style={{ width: '25%' }} />
                <col style={{ width: '25%' }} />
              </colgroup>
              <thead>
                <tr>
                  <th className="font-bold text-center text-black">Component</th>
                  <th className="font-bold text-center text-black">Compatible Versions</th>
                  <th className="font-bold text-center text-black">
                    Recommended / Supported Versions
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <b>PHP</b>
                  </td>
                  <td>8.0.x, 8.1.x, 8.2.x, 8.3.x</td>
                  <td>
                    <b>8.2.x – 8.3.x</b>
                  </td>
                </tr>
                <tr>
                  <td>
                    <b>WordPress</b>
                  </td>
                  <td>6.8.x, 6.9.x</td>
                  <td>
                    <b>6.9.x</b>
                  </td>
                </tr>
                <tr>
                  <td>
                    <b>WooCommerce</b>
                  </td>
                  <td>10.4.x</td>
                  <td>
                    <b>10.4.3</b>
                  </td>
                </tr>
              </tbody>
            </table>
            <p className="text-black light">You will also need:</p>
            <ul className="ml-5 list-disc">
              <li className="text-black light">
                An iQ Pro+ gateway with a default card processor, plus an ACH processor if you
                accept ACH.
              </li>
              <li className="text-black light">
                <b>WooCommerce Subscriptions</b> if you sell subscription products.
              </li>
              <li className="text-black light">
                A public site with a valid SSL certificate to receive webhooks.
              </li>
            </ul>
            <Section id="installation-and-setup" title="Installation & Setup" open>
              <p className="text-black light">
                This section covers the installation and setup process for the{' '}
                <Link
                  to="/integrations-woo-commerce-downloads"
                  style={{ color: '#007bff', textDecoration: 'underline' }}
                >
                  iQ Pro+ WooCommerce Plugin
                </Link>
                .
              </p>
              <div className="my-4 callout">
                <p className="mb-0 text-black light">
                  <strong>NOTE:</strong> Should you install a new version of the plugin, it is
                  recommended you clear your cache to prevent potential errors in testing.
                </p>
              </div>
              <h2 className="font-normal text-black">Uploading the Plugin</h2>
              <ol className="ml-5 list-decimal">
                <li className="text-black light">
                  In the <b>WordPress Admin Panel</b>, navigate to the <b>Plugins</b> section.
                </li>
                <li className="text-black light">
                  Click either the <b>"Add Plugin"</b> option in the sidebar dropdown
                  <img
                    src={screenshotWordpressUpload}
                    alt="Screenshot of WordPress Upload Plugin"
                  />
                  <br />
                  or the <b>"Add New"</b> button on the Installed Plugins page.
                  <img src={screenshotWpAdd} alt="Screenshot of WordPress Add" />
                </li>
                <li className="text-black light">
                  At the top of the page, click the <b>"Upload Plugin"</b> button.
                  <img
                    src={screenshotWpUploadPlugin}
                    alt="Screenshot of WordPress Upload Plugin page"
                  />
                </li>
                <li className="text-black light">
                  Upload the <code>.zip</code> file provided by Basys.
                </li>
                <li className="text-black light">
                  Once the upload completes, click <b>“Install Now”</b> and then <b>“Activate”</b>{' '}
                  to enable the plugin.
                </li>
                <li className="text-black light">
                  Confirm that the plugin is active by returning to the <b>Plugins</b> tab and
                  verifying its status.
                  <img src={screenshotWpPluginPage} alt="Screenshot of WordPress Plugin page" />
                </li>
              </ol>
              <h2 className="font-normal text-black">Enabling the Payment Gateway</h2>
              <ol className="ml-5 list-decimal">
                <li className="text-black light">
                  Navigate to the <b>WooCommerce</b> section in the WordPress Admin Panel and select{' '}
                  <b>Settings</b>.
                </li>
                <li className="text-black light">
                  Click the <b>Payments</b> tab.
                  <img
                    src={screenshotWooCommerceSettings}
                    alt="Screenshot of WooCommerce Settings"
                    width="50%"
                  />
                </li>
                <li className="text-black light">
                  Scroll down to locate <b>Basys Processing iQPro+</b>.
                </li>
                <li className="text-black light">
                  Toggle the switch to <b>Enable</b> the payment gateway.
                  <img
                    src={screenshotWooCommercePaymentGateway}
                    alt="Screenshot of WordPress Plugin page"
                  />
                </li>
              </ol>
              <p
                className="text-black light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                Once enabled, the <b>Basys iQPro+</b> gateway is officially registered as a
                WooCommerce payment processor and the secure iFrame will be available for use during
                checkout.
              </p>
            </Section>
            <Section id="app-registration-setup" title="App Registration Setup">
              <p
                className="text-black light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                For this portion we will need to set up the app registration in your gateway to
                obtain your client ID and client secret. We will start in your gateway portal and
                navigate to <b>Developer Hub → Applications</b>
              </p>

              <img src={screenshotDeveloperHub} alt="Screenshot of Developer Hub" />
              <h2 className="font-normal text-black">Creating the Client Credentials</h2>
              <ol className="ml-5 list-decimal">
                <li className="text-black light">
                  In the <b>Applications</b> page select <b>Create New +</b>
                </li>
                <li className="text-black light">
                  Enter your <b>Application Name</b> and for role select Integrator Service Account
                  and click Create
                  <div className="my-4 callout">
                    <p className="mb-0 text-black light">
                      <strong>IMPORTANT:</strong> The role <span className="underline">MUST</span>{' '}
                      be Integrator Service Account or the plugin will not function.
                    </p>
                  </div>
                  <img src={screenshotCreateNewApp} alt="Screenshot of Create New Application" />
                </li>
                <li
                  className="text-black light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  Once created you will see <b>Client ID</b> listed below your applications name
                  followed by a UUID. This is your <b>Client ID</b> that will be used in the{' '}
                  <b>Config File Setup</b>
                </li>
                <li className="text-black light">
                  Below <b>Details</b> you will see <b>Secrets</b>, select <b>+ Add New Secret</b>{' '}
                  and enter your secrets name
                  <img src={screenshotSecrets} alt="Screenshot of Secrets" />
                  <div className="my-4 callout">
                    <p className="mb-0 text-black light">
                      <strong>NOTE:</strong> Once you create a new secret it will be display on the
                      page. This will be the only time to record this. Additionally you are allowed
                      only two secrets per application
                    </p>
                  </div>
                </li>
                <li className="text-black light">
                  You have now created your client ID and client secret. Save these credentials for
                  the <b>Config File Setup</b> portion of the process
                </li>
              </ol>
            </Section>
            <Section id="settings-page" title="Settings Page">
              <p
                className="text-black light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                Once the plugin has been successfully installed and activated, a new submenu item
                labeled <b>iQPro+ Gateway</b> will appear under the <b>WooCommerce</b> section in
                the WordPress Admin Panel.
              </p>
              <p className="text-black light">Navigate to:</p>
              <p className="font-semibold text-black">WooCommerce → iQPro+ Gateway</p>
              <p
                className="text-black light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                This settings page serves as the central configuration hub for the plugin and
                contains all options required to connect your WooCommerce store to the Basys iQPro+
                gateway.
              </p>
              <p className="text-black light">From this page, you can:</p>
              <ul className="ml-5 list-disc">
                <li className="text-black light">
                  Configure <b>payment method availability</b>, such as Card-only or Card + ACH
                  (depending on gateway setup).
                </li>
                <li className="text-black light">
                  Receive your <b>Webhook URL</b> or edit your pre-generated <b>Webhook ID</b>
                </li>
                <li className="text-black light">
                  Select which <b>environment</b> the plugin should operate in (Sandbox or
                  Production).
                </li>
                <li className="text-black light">
                  Enter your <b>Client ID</b> and <b>Client Secret</b> received from your gateway.
                </li>
                <li className="text-black light">
                  Verify that the <b>credentials defined</b> are functioning correctly.
                </li>
                <li className="text-black light">
                  Configure an admin fee on the <b>Payment Adjustments</b> tab.
                </li>
                <li className="text-black light">
                  Set processor IDs and billing time for subscriptions on the{' '}
                  <b>Subscription Settings</b> tab.
                </li>
                <li className="text-black light">
                  View the <b>Logs</b> to assist in troubleshooting.
                </li>
              </ul>
              <h2 className="font-normal text-black">General Settings</h2>
              <img src={screenshotGeneralSettings} alt="Screenshot of General Settings" />
              <ul className="ml-5 list-disc">
                <li className="text-black light">
                  <b>Enable/Disable</b>: Turns the gateway on or off at checkout.
                </li>
                <li className="text-black light">
                  <b>Title</b>: The payment method name shoppers see at checkout.
                </li>
                <li className="text-black light">
                  <b>Accepted Methods</b>: Card only, or Card and ACH.
                </li>
                <li className="text-black light">
                  <b>Vault Customer</b>: Lets logged-in customers save payment methods. This{' '}
                  <span className="underline">must</span> be on to sell subscriptions.
                </li>
                <li className="text-black light">
                  <b>Webhook ID</b> and <b>Webhook URL</b>: See{' '}
                  <a
                    onClick={openSection}
                    href="#webhook-setup"
                    style={{ color: '#007bff', textDecoration: 'underline' }}
                  >
                    Webhook Setup
                  </a>
                  .
                </li>
                <li className="text-black light">
                  <b>Automate Secret Renewal</b>: Creates a new client secret every 180 days and
                  deletes the old one, so your credentials don't expire.
                </li>
              </ul>
              <p
                className="text-black light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                Any changes made on the Settings page take effect immediately after saving. It is
                recommended to complete all credential and webhook configuration steps prior to
                enabling the gateway on a live production site.
              </p>
            </Section>
            <Section id="credentials-and-environment" title="Credentials and Environment">
              <p
                className="text-black light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                The <b>Environment and API Credentials</b> section allows you to configure how the
                plugin connects to your iQPro+ gateway. From this screen, you will select the active
                environment and provide the corresponding authentication credentials.
              </p>
              <p className="text-black light">Navigate to:</p>
              <p className="font-semibold text-black">
                WooCommerce → iQPro+ Gateway → Environment and Credentials
              </p>
              <img
                src={screenshotWooCommerceGatewaySettings}
                alt="Screenshot of WooCommerce Gateway Settings"
              />
              <h2 className="font-normal text-black">Selecting an Environment</h2>
              <p className="text-black light">
                At the top of the page, choose which environment the plugin should operate in:
              </p>
              <ul className="ml-5 list-disc">
                <li className="text-black light">
                  <b>Sandbox</b> - Used for development and testing
                </li>
                <li className="text-black light">
                  <b>Production</b> - Used for live transactions
                </li>
              </ul>
              <p className="text-black light">
                Only one environment can be active at a time. The selected environment determines
                which credentials are used when processing payments.
              </p>
              <h2 className="font-normal text-black">Entering API Credentials</h2>
              <p className="text-black light">
                For the selected environment, enter the following values provided by Basys:
              </p>
              <ul className="ml-5 list-disc">
                <li className="text-black light">
                  <code>Client ID</code>: The unique identifier for your registered application.
                </li>
                <li className="text-black light">
                  <code>Client Secret</code>: A secure secret key used to authenticate API requests.
                </li>
                <li className="text-black light">
                  <code>Gateway ID</code>: The identifier for the payment gateway assigned to your
                  account.
                  <div className="my-4 callout">
                    <p className="mb-0 text-black light">
                      <strong>IMPORTANT:</strong> Credentials must match the selected environment.
                      Sandbox credentials will not work in Production mode, and Production
                      credentials will not function in Sandbox mode.
                    </p>
                  </div>
                </li>
              </ul>
              <p className="text-black light">
                After entering the required values, click <b>Save All Changes</b> to store your
                configuration.
              </p>
              <h2 className="font-normal text-black">Testing the API Connection</h2>
              <p className="text-black light">
                Once your credentials have been saved, you can validate them by clicking the{' '}
                <b>Test API Connection</b> button.
              </p>
              <p className="text-black light">This test confirms that:</p>
              <ul className="ml-5 list-disc">
                <li className="text-black light">The Client ID and Client Secret are valid</li>
                <li className="text-black light">
                  The Gateway ID is correctly associated with your account
                </li>
                <li className="text-black light">
                  The plugin can successfully authenticate with the iQPro+ API
                </li>
              </ul>
              <p
                className="text-black light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                If the test fails, review the entered credentials and ensure the correct environment
                is selected. For additional guidance, refer to the <b>Troubleshooting</b> tab within
                the plugin settings.
              </p>
            </Section>
            <Section id="webhook-setup" title="Webhook Setup">
              <p
                className="text-black light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                The iQPro+ WooCommerce plugin uses webhooks to receive real-time transaction updates
                from the iQPro+ gateway. These updates allow the plugin to process transaction
                status changes dynamically and keep order data in sync with the gateway.
              </p>
              <img src={screenshotWebhooks} alt="Screenshot of Webhooks" />
              <p
                className="text-black light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                The plugin <b>automatically generates a Webhook URL and Webhook ID</b> during
                installation. These values are exposed within the plugin settings and are ready to
                be used when creating your webhook in the gateway portal.
              </p>
              <div className="my-4 callout">
                <p
                  className="mb-0 text-black light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  <strong>IMPORTANT:</strong> Webhook IDs must be in UUID format in order to
                  function correctly. While the plugin generates this value automatically, it can be
                  manually edited from the Settings page if needed.
                </p>
              </div>
            </Section>
            <Section id="webhook-creation" title="Webhook Creation">
              <p className="text-black light">
                To register the webhook with your iQPro+ gateway, complete the following steps:
              </p>
              <ol className="ml-5 list-decimal">
                <li className="text-black light">
                  Log in to your <b>iQPro+ Gateway Portal</b>.
                </li>
                <li className="text-black light">
                  Navigate to: <b>Developer Hub → Webhooks</b>
                </li>
                <li className="text-black light">
                  Click <b>Create New +</b>.
                </li>
              </ol>
              <h2 className="font-normal text-black">Webhook Configuration</h2>
              <p className="text-black light">
                When creating the webhook, configure the following fields:
              </p>
              <ul className="ml-5 list-disc">
                <li className="text-black light">
                  <b>Webhook Type</b>: Select <b>Transaction</b>
                </li>
                <li
                  className="text-black light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  <b>Webhook URL</b>: Copy and paste the <b>Webhook URL provided by the plugin</b>.
                  This URL is displayed in the plugin’s settings and is already formatted correctly
                  for webhook delivery.
                  <div className="my-4 callout">
                    <p
                      className="mb-0 text-black light"
                      style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                    >
                      <strong>NOTE:</strong> Webhooks require a live, publicly accessible site with
                      a valid and trusted SSL certificate. Local development environments without
                      HTTPS will not receive webhook events.
                    </p>
                  </div>
                </li>
              </ul>
              <p className="text-black light">
                Once all required fields are completed, click <b>Create</b> to save the webhook.
              </p>
            </Section>
            <Section id="accepted-methods" title="Accepted Methods">
              <p
                className="text-black light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                On the <b>Settings</b> page, you can choose whether to accept <b>Card Only</b>{' '}
                payments or both <b>Card and ACH</b> payments. Your selection determines which
                payment options are displayed on your checkout page. Please note that card and ACH
                payments will only function if a <b>default processor</b> has been configured.
              </p>
              <img src={screenshotAcceptableMethods} alt="Screenshot of Accepted Methods" />
              <p className="text-black light">
                <b>Card</b>: Card number and CVV are hosted, tokenized fields, so card data never
                touches your server.
              </p>
              <img src={screenshotCheckoutCard} alt="Screenshot of card fields at checkout" />
              <p className="text-black light">
                <b>ACH</b>: Account type, routing number, and account number.
              </p>
              <img src={screenshotCheckoutAch} alt="Screenshot of ACH fields at checkout" />
              <p
                className="text-black light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                With <b>Vault Customer</b> on, logged-in shoppers can tick{' '}
                <b>Save payment method for future use</b> and choose a saved method on later orders.
                Payment methods are always saved for orders that contain a subscription.
              </p>
            </Section>
            <Section id="payment-adjustments" title="Payment Adjustments & Surcharges">
              <p
                className="text-black light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                Starting with version 1.0.4, you can add one admin fee to orders paid through the
                iQPro+ gateway. If your processor has credit card surcharging enabled, shoppers also
                see the exact surcharge before they place the order. The gateway calculates every
                fee and surcharge amount; the plugin only displays and records them.
              </p>
              <p className="text-black light">Navigate to:</p>
              <p className="font-semibold text-black">
                WooCommerce → iQPro+ Gateway → Payment Adjustments
              </p>
              <img
                src={screenshotPaymentAdjustments}
                alt="Screenshot of Payment Adjustments settings"
              />
              <h2 className="font-normal text-black">Settings</h2>
              <ul className="ml-5 list-disc">
                <li className="text-black light">
                  <b>Enable payment adjustment</b>: Turns the admin fee on or off. Surcharge
                  disclosure is controlled by your processor, not this setting.
                </li>
                <li className="text-black light">
                  <b>Fee type</b>: <b>Service Fee</b> charges a percent of the order total.{' '}
                  <b>Convenience Fee</b> charges a flat dollar amount. Only one applies per
                  transaction.
                </li>
                <li className="text-black light">
                  <b>Amount</b>: The percent for a Service Fee (<code>3</code> = 3%) or the dollar
                  amount for a Convenience Fee. Must be greater than 0; a percentage cannot exceed
                  100.
                </li>
                <li className="text-black light">
                  <b>Label</b>: The fee line name shoppers see in the cart, checkout, receipts, and
                  emails. Surcharge wording is not allowed; use a term like "Admin Fee" or "Service
                  Fee".
                </li>
                <li className="text-black light">
                  <b>Apply to</b>: Which payment methods carry the fee: <b>Card</b>, <b>ACH</b>, or{' '}
                  <b>Both</b>.
                </li>
                <li className="text-black light">
                  <b>Subscription renewals</b>: Adds the fee to renewals of subscriptions created
                  after this is enabled. Card networks restrict convenience fees on recurring
                  transactions.
                </li>
                <li className="text-black light">
                  <b>Compliance attestation</b>: Required to enable the fee.
                </li>
              </ul>
              <div className="my-4 callout">
                <p
                  className="mb-0 text-black light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  <strong>IMPORTANT:</strong> By checking the compliance attestation, you as the
                  merchant are responsible for making sure the fee, alone or combined with any
                  credit card surcharge, complies with card network rules and applicable laws. The
                  plugin does not check state rules, fee caps, or card network requirements.
                </p>
              </div>
              <p
                className="text-black light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                When you save, the plugin checks the amount, the label, and the attestation. If any
                check fails, the fee is disabled and a notice explains why. The label is also
                checked as you type.
              </p>
              <img src={screenshotLabelWarning} alt="Screenshot of the fee label warning" />
              <h2 className="font-normal text-black">What Shoppers See</h2>
              <p
                className="text-black light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                When a shopper selects the iQPro+ gateway, the admin fee appears as its own line in
                the order summary using your label. It is removed if they switch to a payment method
                the fee doesn't apply to. This works the same in the classic checkout, the Block
                checkout, and the Pay for order page.
              </p>
              <img src={screenshotCheckoutAdminFee} alt="Screenshot of the admin fee at checkout" />
              <ul className="ml-5 list-disc">
                <li className="text-black light">
                  <b>Before a card is entered</b>: If surcharging is active, a note says a surcharge
                  may apply to credit cards.
                </li>
                <li className="text-black light">
                  <b>After a card is entered</b>: A surcharged credit card shows{' '}
                  <b>Credit card surcharge (X%)</b> and <b>Total if paying by credit card</b>. Debit
                  and prepaid cards show "No surcharge for debit/prepaid cards."
                </li>
                <li className="text-black light">
                  <b>Placing the order</b>: If a surcharge applies and the shopper hasn't seen it,
                  the order is held so they can review the new total. Clicking <b>Place Order</b>{' '}
                  again submits the payment.
                </li>
                <li className="text-black light">
                  <b>ACH</b>: Never surcharged.
                </li>
              </ul>
              <img
                src={screenshotSurchargeNotice}
                alt="Screenshot of the surcharge review message"
              />
              <div className="my-4 callout">
                <p
                  className="mb-0 text-black light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  <strong>NOTE:</strong> If fees can't be calculated, checkout shows "Fees could not
                  be calculated, please try again." and payment is blocked.
                </p>
              </div>
              <h2 className="font-normal text-black">On the Order</h2>
              <p
                className="text-black light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                The order total always equals the amount the gateway charged. The admin fee and the
                surcharge are separate fee lines, shown on the thank-you page, My Account, order
                emails, and the admin order screen.
              </p>
              <img
                src={screenshotOrderThankYou}
                alt="Screenshot of fee lines on the thank-you page"
              />
              <img
                src={screenshotOrderAdmin}
                alt="Screenshot of fee lines on the admin order screen"
              />
            </Section>
            <Section id="recurring-billing" title="Recurring Billing">
              <p
                className="text-black light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                The plugin bills WooCommerce Subscriptions products through iQ Pro+. When a shopper
                buys a subscription, the plugin creates a matching subscription in iQ Pro+, and iQ
                Pro+ charges each renewal on schedule. WooCommerce does not charge renewals itself,
                so a customer is never billed twice.
              </p>
              <h2 className="font-normal text-black">Before You Start</h2>
              <ul className="ml-5 list-disc">
                <li className="text-black light">
                  Install and activate <b>WooCommerce Subscriptions</b>.
                </li>
                <li className="text-black light">
                  Turn on <b>Vault Customer</b> in General Settings.
                </li>
                <li className="text-black light">
                  Register the{' '}
                  <a
                    onClick={openSection}
                    href="#webhook-creation"
                    style={{ color: '#007bff', textDecoration: 'underline' }}
                  >
                    webhook
                  </a>
                  . Renewal orders are completed by webhook.
                </li>
                <li className="text-black light">
                  Fill in the processor IDs on the <b>Subscription Settings</b> tab.
                </li>
              </ul>
              <h2 className="font-normal text-black">Subscription Settings</h2>
              <p className="text-black light">Navigate to:</p>
              <p className="font-semibold text-black">
                WooCommerce → iQPro+ Gateway → Subscription Settings
              </p>
              <img src={screenshotSubscriptionSettings} alt="Screenshot of Subscription Settings" />
              <ul className="ml-5 list-disc">
                <li className="text-black light">
                  <b>Card Processor ID / ACH Processor ID</b>: The processors used to charge
                  renewals, set per environment. Click <b>Get Processor IDs</b> to fill them from
                  your gateway automatically.
                </li>
                <li className="text-black light">
                  <b>Default Billing Time</b>: The hour of the day iQ Pro+ runs renewal charges
                  (default 6 AM, store time zone). Applies to new subscriptions only.
                </li>
              </ul>
              <h2 className="font-normal text-black">Checkout Rules</h2>
              <ul className="ml-5 list-disc">
                <li className="text-black light">
                  Shoppers must be <b>logged in</b> to buy a subscription.
                </li>
                <li className="text-black light">
                  The payment method is always saved, because renewals charge the saved method.
                </li>
                <li className="text-black light">
                  Free trials and future start dates are passed to iQ Pro+. The order note shows
                  when the term starts and the first payment date.
                </li>
              </ul>
              <h2 className="font-normal text-black">Billing Intervals</h2>
              <table className="tg" style={{ tableLayout: 'fixed', width: '100%' }}>
                <thead>
                  <tr>
                    <th className="font-bold text-center text-black">WooCommerce Interval</th>
                    <th className="font-bold text-center text-black">iQ Pro+ Period</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Every day</td>
                    <td>Daily</td>
                  </tr>
                  <tr>
                    <td>Every week</td>
                    <td>Weekly</td>
                  </tr>
                  <tr>
                    <td>Every 2 weeks</td>
                    <td>Bi-Weekly</td>
                  </tr>
                  <tr>
                    <td>Every month</td>
                    <td>Monthly</td>
                  </tr>
                  <tr>
                    <td>Every 2 months</td>
                    <td>Every 2 months</td>
                  </tr>
                  <tr>
                    <td>Every 3 months</td>
                    <td>Quarterly</td>
                  </tr>
                  <tr>
                    <td>Every year</td>
                    <td>Yearly</td>
                  </tr>
                </tbody>
              </table>
              <div className="my-4 callout">
                <p
                  className="mb-0 text-black light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  <strong>IMPORTANT:</strong> Other intervals are mapped to a different period,
                  which changes how often the customer is billed: every 2+ days becomes Weekly,
                  every 3+ weeks becomes Monthly, and every 4+ months becomes Yearly. An order note
                  and admin notice are added when this happens. Intervals longer than one year are
                  not created in iQ Pro+, and WooCommerce handles those renewals.
                </p>
              </div>
              <h2 className="font-normal text-black">Renewals</h2>
              <ol className="ml-5 list-decimal">
                <li className="text-black light">
                  On the renewal date, WooCommerce creates a renewal order and marks it as waiting
                  on iQ Pro+.
                </li>
                <li className="text-black light">
                  iQ Pro+ charges the saved payment method at the billing time.
                </li>
                <li className="text-black light">
                  The webhook marks the order paid, or failed with the decline reason. A failed
                  renewal puts the subscription on hold, and WooCommerce Subscriptions' retry rules
                  apply.
                </li>
              </ol>
              <p
                className="text-black light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                Status changes in WooCommerce are sent to iQ Pro+: <b>On hold</b> pauses the iQ Pro+
                subscription, <b>Active</b> resumes it, <b>Cancelled</b> cancels it, and{' '}
                <b>Expired</b> completes it. A subscription pending cancellation stays active until
                its end date.
              </p>
              <div className="my-4 callout">
                <p
                  className="mb-0 text-black light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  <strong>NOTE:</strong> Recurring shipping is not sent to iQ Pro+. A subscription
                  with recurring shipping is billed for products, tax, and fees only.
                </p>
              </div>
            </Section>
            <Section id="refunds" title="Refunds">
              <p
                className="text-black light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                Refund orders from the WooCommerce order screen. The plugin sends the refund to iQ
                Pro+.
              </p>
              <ol className="ml-5 list-decimal">
                <li className="text-black light">
                  Open the order and click <b>Refund</b>.
                </li>
                <li className="text-black light">
                  Enter the <b>Refund amount</b>, or fill in the quantities and amounts on each
                  line. Fee lines can be refunded too.
                </li>
                <li className="text-black light">
                  Click <b>Refund $X via Basys Processing</b>.
                </li>
              </ol>
              <img src={screenshotOrderRefund} alt="Screenshot of the refund panel on the order screen" />
              <div className="my-4 callout">
                <p
                  className="mb-0 text-black light"
                  style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                >
                  <strong>IMPORTANT:</strong> <b>Refund manually</b> only records the refund in
                  WooCommerce. No money is sent back to the customer.
                </p>
              </div>
              <p
                className="text-black light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                What happens depends on whether the payment has settled:
              </p>
              <table className="tg" style={{ tableLayout: 'fixed', width: '100%' }}>
                <thead>
                  <tr>
                    <th className="font-bold text-center text-black">Payment</th>
                    <th className="font-bold text-center text-black">Result</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Not settled yet</td>
                    <td>
                      The payment is <b>voided</b>. A void must be for the full order amount. A
                      partial amount shows an error, so wait until the payment settles, then refund
                      part of it.
                    </td>
                  </tr>
                  <tr>
                    <td>Settled</td>
                    <td>
                      The amount you enter is <b>refunded</b>, in full or in part, including any
                      admin fee or surcharge.
                    </td>
                  </tr>
                </tbody>
              </table>
              <p
                className="text-black light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                Each refund or void adds an order note. Once the full amount is refunded, the order
                is marked <b>Refunded</b>. A voided order may then change to <b>Cancelled</b> when
                iQ Pro+ confirms the void. If a refund fails, the order note shows the reason from
                iQ Pro+.
              </p>
              <h2 className="font-normal text-black">Refunds Made in the iQ Pro+ Portal</h2>
              <p
                className="text-black light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                With the{' '}
                <a
                  onClick={openSection}
                  href="#webhook-creation"
                  style={{ color: '#007bff', textDecoration: 'underline' }}
                >
                  webhook
                </a>{' '}
                registered, a matching refund is added to the WooCommerce order with an order note.
                Refunds made from the order screen are not added twice.
              </p>
            </Section>
            <Section id="logging" title="Logging">
              <p
                className="text-black light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                To help troubleshoot any errors that may occur this plugin comes with its own
                logging. You can find this under the <b>Troubleshooting</b> tab then selecting the{' '}
                <b>Open WooCommerce Logs</b> button or by going to{' '}
                <b>WooCommerce → Status → Logs</b>, should there be any they would be logged under
                the file names basys-payment-gateway
              </p>
              <img src={screenshotLogging} alt="Screenshot of Logging" />
            </Section>
            <Section id="styling" title="Styling">
              <p
                className="text-black light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                To ensure seamless integration with your site’s branding, the plugin applies only
                minimal default styling and relies primarily on your active theme and global site
                styles for overall appearance.
              </p>
              <p
                className="text-black light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                The included CSS establishes a clean, consistent baseline that works across a wide
                variety of WordPress themes while remaining flexible and easy to customize. No
                aggressive styling or layout overrides are applied by default.
              </p>
              <h2 className="font-normal text-black">Expected Styling Behavior</h2>
              <p
                className="text-black light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                Out of the box, the plugin is designed to exhibit the following behaviors:
              </p>
              <ul className="ml-5 list-disc">
                <li className="text-black light">
                  Automatically expand to <b>match the full width</b> of the container it is placed
                  within.
                </li>
                <li className="text-black light">
                  Display section titles and labels using <b>bold text and consistent spacing</b>{' '}
                  for clarity.
                </li>
                <li className="text-black light">
                  Structure Card and ACH entry forms using <b>flexible layouts</b> that adapt
                  smoothly to both desktop and mobile viewports.
                </li>
                <li className="text-black light">
                  Apply <b>uniform input styling</b> across all Card and ACH fields, including font
                  size, padding, borders, and rounded corners.
                </li>
                <li className="text-black light">
                  Maintain visual consistency between native WooCommerce elements and the embedded
                  payment fields.
                </li>
                <li className="text-black light">
                  Gracefully hide or reveal payment sections (Card, ACH, Vault options) based on
                  configuration and user interaction.
                </li>
              </ul>
              <p
                className="text-black light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                This approach ensures the checkout experience feels native to your site while
                maintaining a consistent payment flow across implementations.
              </p>
              <h2 className="font-normal text-black">Editing the Styling</h2>
              <p
                className="text-black light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                If additional customization is required, the plugin’s appearance can be modified
                directly by editing the following files:
              </p>
              <ul className="ml-5 list-disc">
                <li className="text-black light">
                  <code>basys-payment-styles.css</code>: The primary stylesheet controlling layouts.
                </li>
                <li className="text-black light">
                  <code>styleLoader.js</code>: Contains styling logic specific to the embedded
                  iframe, including injected styles for hosted fields.
                </li>
              </ul>
              <h2 className="font-normal text-black">HTML Structure Reference</h2>
              <p
                className="text-black light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                For convenience, the full HTML structure rendered by the plugin is provided below.
                This can be used as a reference when making targeted CSS or JavaScript
                customizations.
              </p>
              <CopyBlock
                text={`<div id="basys-payment-box" class="basys-payment-wrapper">
    <input type="hidden" name="basys_payment_method" id="basys_payment_method" value="card" />
    <!-- Toggle Buttons -->
    <div class="basys-payment-toggle hidden">
        <button type="button" id="select-card" class="toggle-button selected">Card</button>
        <button type="button" id="select-ach" class="toggle-button">ACH</button>
    </div>
    <!-- Card Payment -->
    <div class="payment-card-label hidden">Card Information</div>
    <div class="payment-card-section hidden">
        <div class="info-items">
            <div id="tokenex-container"></div>
        </div>
        <div class="info-items info-box">
            <input
                type="text"
                id="basys-expiration"
                name="expiration_date"
                placeholder="MM/YY"
                inputmode="numeric"
                autocomplete="cc-exp"
                maxlength="5"
                required
                pattern="^(0[1-9]|1[0-2])\\/\\d{2}$"
            />
        </div>
        <div class="info-items info-box">
            <div id="tokenex-container-cvv"></div>
        </div>
    </div>
    <!-- ACH Payment -->
    <?php if ($ach_enabled): ?>
        <div class="payment-bank-section" hidden>
            <div class="info-items">
                <label for="achAccountType">Account Type</label>
                <select id="achAccountType" name="achAccountType">
                    <option value="Checking">Checking</option>
                    <option value="Savings">Savings</option>
                </select>
            </div>
            <div class="info-items">
                <label for="routingNumber">Routing Number</label>
                <input
                    type="text"
                    id="routingNumber"
                    name="routingNumber"
                    inputmode="numeric"
                    autocomplete="off"
                    maxlength="9"
                    pattern="^\\d{9}$"
                />
            </div>
            <div class="info-items">
                <label for="accountNumber">Account Number</label>
                <input
                    type="text"
                    id="accountNumber"
                    name="accountNumber"
                    inputmode="numeric"
                    autocomplete="off"
                    maxlength="17"
                    pattern="^\\d{4,17}$"
                />
            </div>
        </div>
    <?php endif; ?>
    <?php if ($is_user_logged_in && $vault_customer_enabled): ?>
        <div class="vault-payment-option hidden">
            <input type="checkbox" id="basys-vault-payment" name="basys_vault_payment" />
            <label for="basys-vault-payment">Save payment method?</label>
        </div>
    <?php endif; ?>
</div>
`}
                theme={dracula}
                customStyle={{ overflowX: 'auto' }}
                language="php"
              />
            </Section>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default DeveloperWooCommerce;
export { Section, openSection };
